import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import CabinetReferralMain from "../../components/cabinetReferralMain";
import CabinetReferralTable from "../../components/cabinetReferralTable";
import {useDispatch, useSelector} from "react-redux";
import {getReferrals, getReferralsMain} from "../../store/cabinet/action";
import {useNavigate} from "react-router-dom";
import CabinetReferralModal from "../../components/cabinetReferralModal";



const CabinetReferralPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(() => {
        dispatch(getReferralsMain());
        dispatch(getReferrals());
    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetReferralMain/>
                <CabinetReferralTable/>
                <CabinetReferralModal/>
            </div>
        </section>
    );
};

export default CabinetReferralPage;
